/**
 * Cuánto dura la sesión en este navegador.
 *
 * - "Recordar sesión" sin marcar: la sesión termina al cerrar el navegador. El
 *   token vive en localStorage, que sobrevive al cierre, así que al iniciar
 *   sesión se deja además una cookie de sesión: sin fecha de vencimiento, el
 *   navegador la borra al cerrarse, y la ven todas las pestañas (sessionStorage
 *   es de cada pestaña y cerraría la sesión al abrir una nueva). Si con la
 *   preferencia en false la cookie ya no está, el navegador se cerró. Ojo: con
 *   "Continuar donde lo dejaste", Chrome restaura las cookies de sesión.
 * - Marcado: la sesión dura lo que el access-token (10 h). La web no recibe
 *   refresh token del back, así que no se puede renovar.
 *
 * La preferencia se guarda con vue-ls como "remember_session" (Login.vue).
 */
const COOKIE_SESION = "kaik_admin_sesion";

// Cuánto antes de que venza el token se avisa que la sesión se va a cerrar
export const AVISO_ANTES_MS = 5 * 60 * 1000;

export function marcarSesionNavegador() {
  document.cookie = `${COOKIE_SESION}=1; path=/; SameSite=Lax`;
}

export function borrarMarcaSesion() {
  document.cookie = `${COOKIE_SESION}=; path=/; max-age=0; SameSite=Lax`;
}

function hayMarcaSesion() {
  return document.cookie.split("; ").includes(`${COOKIE_SESION}=1`);
}

/**
 * Momento en que vence el access-token (exp del JWT), en ms.
 *
 * @returns {number|null} - null si no hay token o no trae exp.
 */
export function vencimientoToken() {
  const token = localStorage.getItem("access-token");
  if (!token) return null;
  try {
    // El payload va en base64url
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const { exp } = JSON.parse(atob(payload));
    return exp ? exp * 1000 : null;
  } catch {
    return null;
  }
}

/**
 * Por qué la sesión guardada ya no sirve.
 *
 * @param {boolean|null} recordarSesion - La preferencia del login. Solo false
 * (sin marcar) limita la sesión al navegador; sin preferencia guardada no.
 * @returns {"token"|"navegador"|null} - "token" si venció el access-token,
 * "navegador" si no se pidió recordar la sesión y el navegador se cerró, null
 * si sigue vigente o no hay sesión.
 */
export function motivoCierreSesion(recordarSesion) {
  if (!localStorage.getItem("access-token")) return null;
  const vence = vencimientoToken();
  if (vence && Date.now() >= vence) return "token";
  if (recordarSesion === false && !hayMarcaSesion()) return "navegador";
  return null;
}
